import { render, staticRenderFns } from "./StateStratalisPublication.vue?vue&type=template&id=72c7aaca&scoped=true&lang=html&"
import script from "./StateStratalisPublication.vue?vue&type=script&lang=coffee&"
export * from "./StateStratalisPublication.vue?vue&type=script&lang=coffee&"
import style0 from "./StateStratalisPublication.vue?vue&type=style&index=0&id=72c7aaca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c7aaca",
  null
  
)

component.options.__file = "StateStratalisPublication.vue"
export default component.exports